import http, {configJson} from "@/api/config/http-configs";


// data 结构 {"name":"分部-21","address":"分部地址-2","comments":"这是分部地址-2","parentId":2}
export const addArea = (data) => {
    let url = "/manage/device/area/add"
    return http.post(url, data, configJson)
}

// data 结构 {"id":6,"name":"分部-21","address":"分部地址-2","comments":"这是分部地址-2","parentId":2}
export const updateArea = (data) => {
    let url = "/manage/device/area/update"
    return http.post(url, data, configJson)
}


export const delArea = (areaId) => {
    let url = `/manage/device/area/delete/${areaId}`
    return http.get(url)
}

export const getAllArea = () => {
    let url = `/manage/device/area/list/all`
    return http.get(url)
}

export const deviceCreate = (data) => {
    let url = `/manage/device/create`
    return http.post(url, data, configJson)
}

// {"id":2,"name":"test","areaId":100,"verify":"VALID"}
export const deviceUpdate = (data) => {
    let url = `/manage/device/update`
    return http.post(url, data, configJson)
}

export const deviceDelete = (deviceId) => {
    let url = `/manage/device/delete/${deviceId}`
    return http.get(url)
}

export const getAllDevices = () => {
    let url = `/manage/device/list/all`
    return http.get(url)
}

// 区域授权管理
export const addAreaAuth = (data) => {
    let url = `/manage/areaAuth/add`
    return http.post(url, data, configJson)
}

export const updateAreaAuth = (data) => {
    let url = `/manage/areaAuth/update`
    return http.post(url, data, configJson)
}

export const deleteAreaAuth = (id) => {
    let url = `/manage/areaAuth/delete/${id}`
    return http.get(url)
}

export const getAllAreaAuth = () => {
    let url = `/manage/areaAuth/list/all`
    return http.get(url)
}
